import { render, staticRenderFns } from "./AccountConfigurationDetails.vue?vue&type=template&id=44353c38&scoped=true"
import script from "./AccountConfigurationDetails.vue?vue&type=script&lang=js"
export * from "./AccountConfigurationDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountConfigurationDetails.vue?vue&type=style&index=0&id=44353c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44353c38",
  null
  
)

export default component.exports